import LockOpenIcon from '@mui/icons-material/LockOpen';
import { Box, Container, CssBaseline, Paper, Stack, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router';

import { ApplicationRoutes } from '../../../../../../application/constants/routes';
import { ILocalization, ILocalizationToken } from '../../../../../../application/language/ILocalization';
import { inject } from '../../../../../../common/container/inject';
import { IAdditionalSignInStrategy } from '../../../../../user/page/login/SignInPageInjects';
import { ISignInPageDomain, SignInPageDomainToken } from '../../../../../user/page/login/store/ISignInPageDomain';
import { MainLayout } from '../../../MainLayout';
import { IMainLayoutDomainStore, MainLayoutDomainStoreToken } from '../../../store/domain/IMainLayoutDomainStore';
import { PasswordChangeForm } from './PasswordChangeForm';
import { usePasswordForm } from './usePasswordForm';

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    width: '400px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export const PasswordRequirementsText = () => {
  const [i18n] = useState(inject<ILocalization>(ILocalizationToken));

  return (
    <Stack direction="column" alignItems="start">
      <Typography align="left" variant="body2" mb={2}>
        {i18n.translate('updatePassword.updatePasswordRequirementsBase_part_1')}
      </Typography>
      <Typography align="left" variant="body2">
        {i18n.translate('updatePassword.updatePasswordRequirementsBase_part_2')}
      </Typography>
      <Typography align="left" variant="body2">
        {i18n.translate('updatePassword.passwordRequirements1')}
      </Typography>
      <Typography align="left" variant="body2">
        {i18n.translate('updatePassword.passwordRequirements2')}
      </Typography>
      <Typography align="left" variant="body2">
        {i18n.translate('updatePassword.passwordRequirements3')}
      </Typography>
      <Typography align="left" variant="body2">
        {i18n.translate('updatePassword.passwordRequirements4')}
      </Typography>
    </Stack>
  );
};


export const ForcePasswordChangePage = () => {
  const classes = useStyles();
  const [layoutDomain] = useState<IMainLayoutDomainStore>(inject(MainLayoutDomainStoreToken));
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const returnUrl = searchParams.get('from') || ApplicationRoutes.Root;

  const handleClose = () => {
    window.location.replace(returnUrl);

  };

  const { handleSubmit, formErrors, setFormErrors } = usePasswordForm({
    handleClose,
    layoutDomain,
    showOldPassword: false,
  });
  const [i18n] = useState(inject<ILocalization>(ILocalizationToken));

  return (
    <div>
      <CssBaseline />
      <div className={classes.paper}>
        <PasswordChangeForm
          icon={
            <Box sx={{ background: 'white', borderRadius: 100, width: '45px', height: '45px', display: 'flex' }}>
              <LockOpenIcon sx={{ margin: 'auto', fontSize: '24px', fill: 'black' }} />
            </Box>
          }
          title={
            <Typography variant="h5" textAlign="center">
              {i18n.translate('updatePassword.updatePasswordTitle')}
            </Typography>
          }
          text={<PasswordRequirementsText />}
          showOldPassword={false}
          onSubmit={handleSubmit}
          onCancel={handleClose}
          errors={formErrors}
          setErrors={setFormErrors}
        />
      </div>
    </div>
  );
};
